module.exports = __webpack_public_path__ + "static/media/custom-15000-high.ff73c403.png";